import { createOpenStreetMapLayer } from './layers'

const uid = () => `project-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`

export function createProject() {
  const now = new Date().toISOString()
  return {
    version: '1.0.0',
    id: uid(),
    name: 'Untitled project',
    // A new project begins at a neutral globe-wide view. Saved projects retain
    // their own camera state when restored by the project repository.
    map: { crs: 'EPSG:3857', center: [0, 18], zoom: 1.3 },
    layers: [createOpenStreetMapLayer()],
    processingHistory: [],
    createdAt: now,
    updatedAt: now
  }
}

export function projectManifest(project) {
  return {
    ...project,
    layers: project.layers.map(layer => {
      const manifestLayer = { ...layer }
      delete manifestLayer.data
      return manifestLayer
    })
  }
}
